var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 94,
    viewBox: "0 0 114 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 114,
    height: 94,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1153_2894)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -330,
    y: -888,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "url(#paint0_linear_1153_2894)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.566037,
    d: "M53.1572 100.27C50.1777 78.4092 34.8527 60.0022 13.8634 53.0791C35.6766 50.0775 54.0378 34.8453 60.9773 13.9773C63.9568 35.838 79.2817 54.2451 100.271 61.1683C78.4577 64.1698 60.0967 79.4023 53.1572 100.27Z",
    fill: "#F2DA05",
    stroke: "#111111",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1153_2894",
    x1: 426,
    y1: -888,
    x2: 426,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474002,
    stopColor: "#EAEDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D4E1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1153_2894"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -330,
    y: -888,
    width: 1512,
    height: 982,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar3);
export default __webpack_public_path__ + "static/media/Star3.e711b5a610c4d9d5b5bd9bdc865d9a4a.svg";
export { ForwardRef as ReactComponent };